import { h as __h } from "preact";
/** @import { groupResponse } from "~/backend/validate.js"; */
import { ApiError, authedApiRequest } from "~/lib/api.js";
import { alert } from "~/util/alert.js";
import html from "~/util/html.js";
import Query from "~/util/query.js";
import { confirmModal } from "~/component/ConfirmModal.js";

/**
 * @param {{ orgId: string }} props
 * @param {groupResponse} group
 */
export const deleteGroup = async ({
  orgId
}, group) => {
  const res = await confirmModal({
    title: `Delete '${group.name}'?`,
    action: "Delete",
    body: __h("p", {}, "Members and machines that were assigned to this group will remain.")
  });
  if (!res) return;
  try {
    await authedApiRequest("DELETE", `/v2/orgs/${orgId}/groups`, {
      json: {
        group_ids: [group.id]
      }
    });
    Query.invalidate([`/v2/orgs/${orgId}/groups`], [`/v2/orgs/${orgId}/groups/${group.id}`], [`/ui/admin/orgs/${orgId}/members`], [`/ui/admin/orgs/${orgId}/machines`]);
    return true;
  } catch (err) {
    alert(ApiError.from(err).message, {
      type: "error"
    });
    return;
  }
};